import axiosInstance from "utils/axiosInstance";

export const fetchUserData = async () => {
    const response = await axiosInstance.get("/api/auth/me", {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
    });

    return response.data;
};

export const setUserData = (data) => {
    localStorage.setItem('user', JSON.stringify(data.user));
    localStorage.setItem('favorites', JSON.stringify(data.favorites));
    localStorage.setItem('groups', JSON.stringify(data.groups));
    localStorage.setItem('tags', JSON.stringify(data.tags));
    localStorage.setItem('values', JSON.stringify(data.values));
};